import type { QuestionnairePayload } from "src-next/modules/questionnaire-builder/form-builder/types";
import { getQuestionnaireStatus } from "src-next/modules/questionnaire-builder/questionnaire-management/utils/questionnaireManagementFilterUtils";

/**
 * Questionários que podem ser listados, selecionados ou enviados em contexto clínico
 * (agenda, criação de protocolo, intervenções na consulta).
 *
 * Inclui apenas `active` e `unknown` (última versão publicada segue ativa para o paciente).
 * `status` ausente ou outro valor → mesmo fallback que {@link getQuestionnaireStatus} → `draft` → excluído.
 */
export function isQuestionnaireSelectableForClinicalUse(
  questionnaire: QuestionnairePayload,
): boolean {
  const normalized = getQuestionnaireStatus(questionnaire);
  return normalized === "active" || normalized === "unknown";
}
